import type { RootState } from "@/src/common/redux/store";

export const getCommunities = (state: RootState) => state.community.communities;
export const getActiveCommunityId = (state: RootState) => state.community.activeCommunityId;
export const getActiveCommunity = (state: RootState) =>
	state.community.communities.find((community) => community.id === state.community.activeCommunityId);
export const getActiveMemberRole = (state: RootState) => state.community.activeMemberRole;
